import { request } from "../core/request";
import type { ISolarMasterRequest, ISolarMasterResponse } from "../types/solarMasterTypes";
import { OPERATION_IDS } from "./constants";

const getSolarMasterOperationId = (): string => {
  const operationIds = OPERATION_IDS as Record<string, string>;

  return operationIds.solarMaster || operationIds.solarmaster || "solarmaster";
};

export const solarMaster = async (payload: ISolarMasterRequest): Promise<ISolarMasterResponse> => {
  return request<ISolarMasterResponse, ISolarMasterRequest>({
    operationId: getSolarMasterOperationId(),
    requestData: payload,
  });
};
